<template>
    <div style="width:100%" class="q-px-none q-pt-none q-pb-sm">
        <div class="threshold-rule-row">
            <span class="threshold-rule-prefix text--primary">{{ Translate('If') }}</span>
            <div class="threshold-rule-field threshold-rule-operator-field">
                <q-select outlined dense
                    :label="Translate('Operator')"
                    class="operator-select full-width"
                    :options="condition_types"
                    option-label="text"
                    option-value="value"
                    emit-value
                    map-options
                    v-model="itemCondition"
                    @update:model-value="thresholdChanged"
                    bg-color="white"
                    hide-bottom-space
                    :error="hasOperatorError"></q-select>
            </div>
            <div class="threshold-rule-field threshold-rule-value-field" v-if="itemCondition != 'missing'" >
                <q-select outlined dense
                        class="full-width"
                        :options="relative_units"
                        option-label="text"
                        option-value="value"
                        emit-value
                        map-options
                        v-model="units_from"
                        @update:model-value="thresholdChanged"
                        bg-color="white"
                        hide-bottom-space
                        :error="hasUnitsFromError">
                </q-select>   
            </div>
            <div class="threshold-rule-field threshold-rule-value-field" v-if="units_from == 'abs' && units_from !== 'now'  && itemCondition != 'missing'">
                <q-input v-if="units_from == 'abs' && units_from !== 'now'"
                        outlined dense
                        v-model="abs_from"
                        type="datetime-local"
                        step="900"
                        :label="Translate('Value')"
                        @update:model-value="thresholdChanged"
                        bg-color="white"
                        hide-bottom-space
                        class="full-width"
                        :error="hasAbsFromError">
                </q-input>
            </div>
            <div class="threshold-rule-field threshold-rule-value-field" v-if="units_from != 'abs' && units_from !== 'now' && itemCondition != 'missing'">                    
                <q-input v-if="units_from != 'abs' && units_from !== 'now'"
                        outlined dense
                        type="number"
                        :label="Translate('Value')"
                        v-model.number="value_from"
                        @update:model-value="thresholdChanged"
                        bg-color="white"
                        hide-bottom-space
                        class="full-width"
                        :error="hasValueFromError">
                </q-input>
            </div>
   
            <template v-if="itemCondition != 'inRange' && itemCondition != 'notInRange'">
                <span class="threshold-rule-then text--primary">{{ Translate('then') }}</span>
                <div class="threshold-rule-format-field">
                    <ThresholdformatOptions ref="formatOptions" :EventBus="EventBus" :defaultColor="value.color" @thresholdFormatChanged="thresholdFormatChanged"/>
                </div>
            </template>
        </div>
        <div class="threshold-rule-row q-mt-xs" v-if="itemCondition == 'inRange' || itemCondition == 'notInRange'">
            <span class="threshold-rule-prefix text--primary">{{ Translate('and') }}</span>
            <div class="threshold-rule-field threshold-rule-operator-field">
                <q-select class="full-width"
                        outlined dense
                        :options="relative_units"
                        option-label="text"
                        option-value="value"
                        emit-value
                        map-options
                        v-model="units_to"
                        @update:model-value="thresholdChanged"
                        bg-color="white"
                        hide-bottom-space
                        :error="hasUnitsToError">
                </q-select>
            </div>
            <div class="threshold-rule-field threshold-rule-value-field" v-if="units_to != 'abs' && units_to !== 'now'">
                <q-input v-if="units_to != 'abs' && units_to !== 'now'"
                        outlined dense
                        type="number"
                        :label="Translate('Value')"
                        v-model.number="value_to"
                        @update:model-value="thresholdChanged"
                        bg-color="white"
                        hide-bottom-space
                        class="full-width"
                        :error="hasValueToError">
                </q-input>
            </div>
            <div class="threshold-rule-field threshold-rule-value-field" v-if="units_to == 'abs' && units_to !== 'now'">
                <q-input v-if="units_to == 'abs' && units_to !== 'now'"
                        outlined dense
                        v-model="abs_to"
                        type="datetime-local"
                        step="900"
                        :label="Translate('Value')"
                        @update:model-value="thresholdChanged"
                        bg-color="white"
                        hide-bottom-space
                        class="full-width"
                        :error="hasAbsToError">
                </q-input>
            </div>
            
            <span class="threshold-rule-then text--primary">{{ Translate('then') }}</span>
            <div class="threshold-rule-format-field">
                <ThresholdformatOptions ref="formatOptions" :EventBus="EventBus" :defaultColor="value.color" @thresholdFormatChanged="thresholdFormatChanged"/>
            </div>
        </div>
    </div>
</template>
<script>
    
    import utils from '@/Shared/utils.jsx';
    import filters from '@/Shared/filters.js';
    import common from './common.js';

    import ThresholdformatOptions from './threshold_formatOptions.vue';
    import methods from '@/Shared/methods';

    export default {
        components: {
            ThresholdformatOptions
        },
        // Declare so parent listeners are component emits (Vue 3); same pattern as filter_*.vue (CCDEV-18136).
        emits: ['thresholdValuesChanged', 'thresholdFormatChanged'],
        data: function () {
            return {
                itemCondition: '',
                value_from: '',
                value_to: 0,
                units_from: 'd',
                units_to: '',
                round_from: true,
                round_to: true,
                abs_from: '',
                abs_to: '',
                color:'',
                hasOperatorError: false,
                hasUnitsFromError: false,
                hasAbsFromError: false,
                hasValueFromError: false,
                hasUnitsToError: false,
                hasAbsToError: false,
                hasValueToError: false,
            }
        },
        props: {
            item: Object,
            value: null,
            EventBus: null,
        },
        created() {
            if (!this.value || Object.keys(this.value).length < 1) {

                // Default values for the date threshold
                const now = new Date();
                const year = now.getFullYear();
                let mon = `${now.getMonth()}`; if (mon.length < 2) mon = '0' + mon;
                let day = `${now.getDate()}`; if (day.length < 2) day = '0' + day;

                this.abs_from = `${year}-${mon}-${day}T00:00`; // '2018-06-12T19:30'; // new Date().toISOString();
                this.abs_to = this.abs_from;
            }
            else {
                this.valueChanged(this.value);
            }

            //this.EventBus.$on(`${this.item.ColId}_changed`, this.valueChanged);
        },
        //unmounted() {
        //    this.EventBus.$off(`${this.item.ColId}_changed`, this.valueChanged);
        //},
        watch: {
            abs_to: function (newv) {
                console.warn(`***  abs_to: ${newv} ***`);
            },
            itemCondition  : function (val) {
              this.valueChanged(val);
            }
        },
        computed: {
            relative_units: function () {
                return [
                    { text: this.Translate('Now'), value: 'now' },
                    { text: this.Translate('Seconds ago'), value: 's' },
                    { text: this.Translate('Minutes ago'), value: 'm' },
                    { text: this.Translate('Hours ago'), value: 'h' },
                    { text: this.Translate('Days ago'), value: 'd' },
                    { text: this.Translate('Weeks ago'), value: 'w' },
                    { text: this.Translate('Months ago'), value: 'M' },
                    { text: this.Translate('Years ago'), value: 'y' },
                    { text: this.Translate('Absolute'), value: 'abs' },
                ];
            },
            condition_types: function () {
                return [
                    { text: this.Translate('Greater Than'), value: 'greaterThan' },
                    { text: this.Translate('Greater Than or Equal To'), value: 'greaterThanOrEqualTo' },
                    { text: this.Translate('Less Than'), value: 'lessThan' },
                    { text: this.Translate('Less Than or Equal To'), value: 'lessThanOrEqualTo' },
                    { text: this.Translate('Equals'), value: 'equals' },
                    { text: this.Translate('Does Not Equal'), value: 'notEquals' },
                    { text: this.Translate('Between'), value: 'inRange' },
                    { text: this.Translate('Not Between'), value: 'notInRange' },
                    { text: this.Translate('Missing'), value: 'missing' },
                ];
            },
            computeCurrentStart: function() {
                return common.getRelativeDate(this.units_from, this.value_from, this.abs_from, this.round_from);
            },
            computeCurrentEnd: function () {
                return common.getRelativeDate(this.units_to, this.value_to, this.abs_to, this.round_to, true);
            },
            friendlyFromUnit: function() {
                return this.getFriendlyUnit(this.units_from);
            },
            friendlyToUnit: function () {
                return this.getFriendlyUnit(this.units_to);
            },

            computeLocalStart: function () {
                if (this.abs_from)
                    return common.ISO8601ToLocal(this.abs_from);
                return '';
            },
            computeLocalEnd: function () {
                if (this.abs_to)
                    return common.ISO8601ToLocal(this.abs_to);
                return '';
            },  
            isRangeBased: function() {
                    return this.itemCondition == 'inRange' || this.itemCondition == 'notInRange';
            },
            operatorRules() {
                return [
                    v => !!v || this.Translate('Please select an operator')
                ];
            },
            absFromRules() {
                return [
                    v => !!v || v === 0 || this.Translate('Please select an option')
                ];
            },
            unitsFromRules() {
                return [
                    v => !!v || v === 0 || this.Translate('Please select an option')
                ];
            },
            valueFromRules() {
                return [
                    v => !!v || v === 0 || this.Translate('Please enter a value')
                ];
            },
            unitsToRules() {
                return [
                    v => !!v || v === 0 || this.Translate('Please select an option')
                ];
            },
            valueToRules() {
                return [
                    v => !!v || v === 0 || this.Translate('Please enter a value')
                ];
            },
            absToRules() {
                return [
                    v => !!v || v === 0 || this.Translate('Please enter a value')
                ];
            },
        },
        methods: {
            ...methods,
                     
            valueChanged(val) {
                if (val.value == 'now')
                    this.units_from = 'now';
                else if (val.value && val.value.substring(0, 3) == 'now') {
                    const { value, units, round } = common.parseFilter(val.value);
                    this.value_from = value;
                    this.units_from = units;
                    this.round_from = round;
                }
                else if (val.value && val.value.includes('T')) {
                    this.units_from = 'abs';
                    this.abs_from = common.ISO8601ToLocal(val.value);
                }

                if (val.valueTo == 'now')
                    this.units_to = 'now';
                else if (val.valueTo && val.valueTo.substring(0, 3) == 'now') {
                    const { value, units, round } = common.parseFilter(val.valueTo);
                    this.value_to = value;
                    this.units_to = units;
                    this.round_to = round;
                }
                else if (val.valueTo && val.valueTo.includes('T')) {
                    this.units_to = 'abs';
                    this.abs_to = common.ISO8601ToLocal(val.valueTo);
                }
                if (val.operator)
                {
                    this.itemCondition = val.operator;
                }
            },            
            thresholdFormatChanged(message){
                this.$emit('thresholdFormatChanged', message);
            },
            thresholdChanged() {

                    if (this.units_from == "now")
                    {
                        this.abs_from = "";
                        this.value_from = "";
                    } else if (this.units_from == "abs")
                    {
                        this.value_from = "";
                    } else 
                    {
                          this.abs_from = "";                      
                    }

                    if (this.units_to == "now")
                    {
                        this.abs_to = "";
                        this.value_to  = "";
                    } else if (this.units_to == "abs")
                    {
                        this.value_to = "";
                    } else 
                    {
                          this.abs_to = "";                      
                    }

                    if (this.itemCondition == 'missing')
                    {
                        this.units_from = "";
                        this.value_from = "";
                        this.abs_from = "";
                        this.round_from = "";
                        this.units_to = "";
                        this.value_to = "";
                        this.abs_to = "";
                        this.round_to = "";
                    }
                    console.log("Units From is: " + this.units_from);
                    console.log("Units To is: " + this.units_to);
                    const rule = {
                        filterType: 'number',
                        type: 'date',
                        value: this.getRelativeQuery(this.units_from, this.value_from, this.abs_from, this.round_from),
                        valueTo: this.getRelativeQuery(this.units_to, this.value_to, this.abs_to, this.round_to),
                        operator: this.itemCondition
                    };                  
                    this.$emit('thresholdValuesChanged', rule);

            },
            clearDateRangeHandler() {
            },

            formatDate(date){
                return filters.f_date(date, 'medium');
            },
            getFriendlyUnit(unit) {
                switch (unit) {
                    case 's': return this.Translate('second');
                    case 'm': return this.Translate('minute');
                    case 'h': return this.Translate('hour');
                    case 'd': return this.Translate('day');
                    case 'w': return this.Translate('week');
                    case 'M': return this.Translate('month');
                    case 'y': return this.Translate('year');
                    default: return '';
                }
            },
            getWeek(date) {
                let yearStart = new Date(date.getFullYear(), 0, 1);
                let today = new Date(date.getFullYear(), date.getMonth(), date.getDate());
                let dayOfYear = ((today - yearStart + 1) / 86400000);
                let week = Math.ceil(dayOfYear / 7);
                return week;
            },
            getDateOfWeek(w, y) {
                var d = (1 + (w - 1) * 7); // 1st of January + 7 days for each week

                return new Date(y, 0, d);
            },

            isActive(unit_type, unit_value, abs_value) {
                if (unit_type == 'now')
                    return true;
                else if (unit_type == 'abs')
                    return abs_value !== '';
                else
                    return unit_value !== '';
            },
            getRelativeQuery(unit_type, unit_value, abs_value, round) {
                if (unit_type == 'abs')
                    return new Date(abs_value).toISOString();

                let value = 'now';
                
                if (unit_type != 'now' && unit_value > 0)
                    value += `-${unit_value}${unit_type}`;
                else if (unit_type != 'now' && unit_value < 0)
                    value += `+${-unit_value}${unit_type}`;
                
                if (round && unit_type != 'now')
                    value += '/' + unit_type;

                return value;
            },
            triggerValidation() {
                this.hasOperatorError = common.hasValidationError(this.operatorRules, this.itemCondition);
                this.hasUnitsFromError = false;
                this.hasAbsFromError = false;
                this.hasValueFromError = false;
                this.hasUnitsToError = false;
                this.hasAbsToError = false;
                this.hasValueToError = false;

                if (this.itemCondition != 'missing') {
                    this.hasUnitsFromError = common.hasValidationError(this.unitsFromRules, this.units_from);

                    if (this.units_from == 'abs' && this.units_from !== 'now')
                        this.hasAbsFromError = common.hasValidationError(this.absFromRules, this.abs_from);
                    else if (this.units_from != 'abs' && this.units_from !== 'now')
                        this.hasValueFromError = common.hasValidationError(this.valueFromRules, this.value_from);
                }

                if (this.itemCondition == 'inRange' || this.itemCondition == 'notInRange') {
                    this.hasUnitsToError = common.hasValidationError(this.unitsToRules, this.units_to);

                    if (this.units_to == 'abs' && this.units_to !== 'now')
                        this.hasAbsToError = common.hasValidationError(this.absToRules, this.abs_to);
                    else if (this.units_to != 'abs' && this.units_to !== 'now')
                        this.hasValueToError = common.hasValidationError(this.valueToRules, this.value_to);
                }
            },
            validate() {
                this.triggerValidation();
                const formatValid = this.$refs.formatOptions?.validate?.() ?? true;
                const hasErrors = this.hasOperatorError || this.hasUnitsFromError || this.hasAbsFromError ||
                    this.hasValueFromError || this.hasUnitsToError || this.hasAbsToError || this.hasValueToError;
                return !hasErrors && formatValid;
            },
        }
    }
</script>

<style src="./threshold_row.css"></style>

<style scoped lang="scss">
    .verydense {
        max-height: 24px;
        min-height: 24px;
    }

    .mediumdense {
        max-height: 28px;
        min-height: 28px;
    }

    .customGrid {
        display: grid; 
        grid-template-columns: 1fr 4em 1fr; 
        grid-template-rows: auto;
        gap: 8px;
        justify-items: start;
        align-items: center;
    }

    .d-flex-compat {
        display: flex;
        flex-wrap: nowrap;
    }

    .operator-select {
        flex: 1 1 auto;
        min-width: 0;
    }

    .consistentText {
        color: var(--v-black-base) !important; 
        opacity: 0.8 !important; 
        font-size: 14px !important; 
        text-rendering: optimizelegibility !important; 
        letter-spacing:0.1 !important;
    }
</style>
